/**
 * Aba Outros → Contatos — C-75 (ajuste de tela do Gabriel, 14/10).
 *
 * Lista TODOS os contatos (emergência + suporte por empresa) e é o ÚNICO lugar de
 * edição; o modal 🚨 do Header fica só leitura. Para admin: ✏️ em cada contato,
 * inativos visíveis com o selo "Inativo" e um único "+ Novo contato" no topo.
 * Gate ESPELHADO na UI (`admin`); o gate real é a RLS de `contacts`.
 */
import { useState } from 'react';
import { empresasVisiveis } from '@/domain/outros';
import { useContatosDaAba } from '@/hooks/useContatosDaAba';
import type { ContatoGestao } from '@/services/datasources';
import ContatoForm from './ContatoForm';
import ContatosEmergencia from './ContatosEmergencia';
import ContatosSuporteView from './ContatosSuporte';

/** `contato: null` = criação. */
type Edicao = { contato: ContatoGestao | null };

export default function ContatosAba({ admin }: { admin: boolean }) {
  const { emergencia, suporte, todos } = useContatosDaAba(admin);
  const [edicao, setEdicao] = useState<Edicao | null>(null);
  const onEditar = admin ? (contato: ContatoGestao) => setEdicao({ contato }) : undefined;

  // Sugestões de empresa: sem as seções arquivadas, a não ser que ainda tenham contato ativo.
  const empresas = [
    ...new Set([
      ...empresasVisiveis(todos).map((e) => e.empresa),
      ...todos.flatMap((c) => (c.is_active && c.empresa ? [c.empresa] : [])),
    ]),
  ];

  return (
    <div className="space-y-4">
      {admin && (
        <div className="flex flex-wrap items-center justify-between gap-2">
          <p className="text-[11px] text-jf-muted">
            Só administradores editam. Desativar tira o contato das listas sem apagá-lo; dá para ativar de novo.
          </p>
          <button
            type="button"
            onClick={() => setEdicao({ contato: null })}
            className="rounded-md border border-jf-yellow/60 px-3 py-1.5 text-xs font-bold text-jf-yellow hover:bg-jf-yellow/10"
          >
            + Novo contato
          </button>
        </div>
      )}

      <ContatosEmergencia bloco={emergencia} onEditar={onEditar} />
      <ContatosSuporteView bloco={suporte} onEditar={onEditar} />

      <p className="text-[11px] text-jf-dim">
        Nome, telefone e e-mail dos contatos vêm do cadastro seguro no cloud (padrão de contatos,
        LGPD). Onde ainda não há cadastro, o contato aparece como pendente.
      </p>

      {edicao && (
        <ContatoForm contato={edicao.contato} todos={todos} empresas={empresas} onClose={() => setEdicao(null)} />
      )}
    </div>
  );
}
